
//Creates the options for the dropdown in quiz page
//Quiz page fetches the assignment completion and sends it to this function
//Then this function calculates the percentage done of the assignment completion and adds stars where necessary
export function CreateAssignmentOptionCompletion(assignmentData){
    let assignmentOptions = [];
    for(let i = 0; i < assignmentData.length; i ++){
        let count = 0;

        for(let g = 0; g < assignmentData[i].length; g++){
            if(assignmentData[i][g] === 1){
                count+=1
            }
        }
        let percentage = count/assignmentData[i].length*100;
        if(percentage <= 25){
            assignmentOptions.push('Assignment ' + (i+1) + ' ⭑')
        } else if(percentage > 25 && percentage <= 50){
            assignmentOptions.push('Assignment ' + (i+1) + ' ⭑⭑')
        }else if(percentage > 50 && percentage <= 75){
            assignmentOptions.push('Assignment ' + (i+1) + ' ⭑⭑⭑')
        }else if(percentage > 75 && percentage <= 100){
            assignmentOptions.push('Assignment ' + (i+1) + ' ⭑⭑⭑⭑')
        }
    }
    for(let i = 0; i < assignmentOptions.length; i++){
        assignmentOptions[i] = {
            key: i,
            text: assignmentOptions[i],
            value: i
        }
    }
    return assignmentOptions;
}
